import { Component, EventEmitter, Input, Output } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { BootstrapIcon } from "src/app/services/header.service";

@Component({
  selector: "app-edit-delete-buttons",
  standalone: true,
  imports: [CommonModule, RouterModule],
  template: `
    <div class="pt-3 pb-2">
      <button
        class="btn btn-qundis-primary qundis-btn-layer2 width-30 p-2 me-2"
        [routerLink]="routeTo"
        [queryParams]="{ formAction: 'edit' }"
        (click)="onEdit()"
      >
        <i [class]="BootstrapIcon.edit" class="me-2"></i
        >{{ this.itemToEdit }} bearbeiten
      </button>
      <button
        class="btn btn-qundis-warn qundis-btn-layer2 width-30 p-2 ms-2"
        (click)="onDelete()"
      >
        <i [class]="BootstrapIcon.delete" class="me-2"></i
        >{{ this.itemToEdit }} löschen
      </button>
    </div>
  `,
  styles: [],
})
export class EditDeleteButtonsComponent {
  BootstrapIcon = BootstrapIcon;
  @Input() routeTo: string;
  @Input() itemToEdit: string;
  @Input() message: string;
  @Output() editEvent = new EventEmitter<void>();
  @Output() deleteEvent = new EventEmitter<void>();

  onEdit() {
    this.editEvent.emit();
  }

  onDelete() {
    if (confirm(this.message)) {
      this.deleteEvent.emit();
    }
  }
}
